import React, { Component } from 'react';
import PropTypes from 'prop-types';
const propTypes = {
  /**
   * Array of objects that makes up complex value;
   * expects <code>{Name: String, Value: String, IsPrimary: Boolean}</code>
   **/
  values: PropTypes.array,
  /**
   * Identifier for automated tests added to the `data-qa` HTML attribute
   **/
  qaId: PropTypes.string
};
const defaultProps = {
  values: [],
  qaId: ''
};
class DataCardComplex extends Component {
  createSubItem(title, value, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "asc-card-column"
    }, /*#__PURE__*/React.createElement("p", null, title), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, value)));
  }
  render() {
    let {
      values,
      qaId
    } = this.props;
    let primary = values.filter(value => {
      return value.IsPrimary;
    })[0];
    let subitems = values.filter(value => {
      return !value.IsPrimary;
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "asc-card asc-card--data  asc-card--formatted asc-flex",
      "data-qa": qaId
    }, /*#__PURE__*/React.createElement("div", {
      className: "asc-card-column",
      "data-qa": "primary-card-data"
    }, /*#__PURE__*/React.createElement("p", {
      className: "asc-card-title"
    }, primary.Name), /*#__PURE__*/React.createElement("p", {
      className: "asc-card-value"
    }, primary.Value)), /*#__PURE__*/React.createElement("div", {
      className: "asc-card-column",
      "data-qa": "secondary-card-data"
    }, subitems.map((subitem, index) => {
      return this.createSubItem(subitem.Name, subitem.Value, index);
    })));
  }
}
DataCardComplex.propTypes = propTypes;
DataCardComplex.defaultProps = defaultProps;
export default DataCardComplex;